import { type FC } from 'react';

type Props = {
    height: number;
    classNames?: string;
};

export const PdpMobileSharedPlaceholder: FC<Props> = ({ height, classNames = '' }) => {
    return <div className={classNames} style={{ height: `${height}px` }} />;
};
